import {Component, Vue} from 'vue-property-decorator'
import {
    getPreProjectMarketCooperationList,
    getPreProjectMarketCooperationListByMarketCooperationId,
    getMarketCooperationList,
    setPreProjectMarketCooperation,
    delPreProjectMarketCooperationByMarketCooperationId,
    getProjectMarketCooperationByMarketCooperationId,
    setProjectMarketCooperation,
    delPreProjectMarketCooperationById,
    setProjectMarketCooperationByIsDraft
} from '@/api/projectList'
import {getDraftById, setDraftById} from '@/api/draft'

@Component({})
export default class ShelfPartnerProject extends Vue {
    addPartnerDialog = false
    addProjectDialog = false
    confirmSubmitError = false
    submitError = false
    confirmSubmitErrorPartnerName = ''
    submitButtonDisabled = false
    draftButtonDisabled = false
    saveButtonDisabled = false
    partnerList = []

    partnerTableDataDialog = []
    dialogPartnerTableCheckedRow = []
    dialogPartnerPage = 1
    dialogPartnerTotal = 0
    dialogPartnerLimit = 20
    dialogPartnerInputValue = ''
    dialogPartnerLoading = false

    projectTableDataDialog = []
    dialogProjectTableCheckedRow = []
    dialogProjectPage = 1
    dialogProjectTotal = 0
    dialogProjectLimit = 20
    dialogProjectInputValue = ''
    dialogProjectLoading = false
    setProjectPartnerId: number = undefined

    draftId: number | '' = ''
    isAll = '0' // 是否有全选标识
    postPage = 1
    postTotal = 0
    postLimit = 20
    souCourseName = ''
    souCourseName1 = ''
    itemLoading = false

    get partnerTableDataEmpty() {
        return this.partnerList.filter(item => item.tableData.length === 0)
    }

    get partnerTableDataError() {
        return this.partnerList.filter(item => item.tableData.every(elm => elm.isShow) === false)
    }

    created() {
        this.draftId = this.$route.query.id ? Number(this.$route.query.id as string) : undefined

        this.getPreProjectMarketCooperationList()
        // window.onbeforeunload = async function() {
        //     // 浏览器关闭或者刷新
        // }
    }

    async getPreProjectMarketCooperationList() {
        if (this.draftId) {
            this.getDraftById()
        } else {
            /*预上架信息合作伙伴列表*/
            const data: any = await getPreProjectMarketCooperationList()
            if (this.partnerList.length > 0) {
                const arr = this.partnerList
                this.partnerList = data.preProjectMarketCooperationList.map(item => ({
                    ...item,
                    tableData: [],
                    souCourseName: ''
                }))
                for (let i = 0; i < this.partnerList.length; i++) {
                    const arrItem = this.partnerList[i];
                    for (let j = 0; j < arr.length; j++) {
                        const partnerListItem = arr[j];
                        if (arrItem.marketCooperationId === partnerListItem.marketCooperationId) {
                            if (arrItem.tableData.length > 0) {
                                partnerListItem.tableData = arrItem.tableData
                            }
                        }
                    }
                }
            } else {
                this.partnerList = data.preProjectMarketCooperationList.map(item => ({
                    ...item,
                    tableData: [],
                    souCourseName: ''
                }))
            }
            //     this.partnerList.forEach(async item => {
            //         // const data: any = this.draftId ? await getPreProjectMarketCooperationListByMarketCooperationId(item.marketCooperationId, this.draftId) : await getPreProjectMarketCooperationListByMarketCooperationId(item.marketCooperationId);
            //         const data: any = await getPreProjectMarketCooperationListByMarketCooperationId(item.marketCooperationId);
            //         console.log('111');
            //         item.tableData = data.preProjectMarketCooperationList;
            //     })
        }
    }

    async getDraftById() {
        /*②详情*/
        const data: any = await getDraftById(this.draftId)
        // console.log(data);
        this.partnerList = data.result.map(item => ({...item, tableData: [], souCourseName: ''}))
        this.partnerList.forEach(async item => {
            this.itemLoading = true
            const data: any = await getPreProjectMarketCooperationListByMarketCooperationId(
                {
                    limit: this.postLimit,
                    page: this.postPage,
                    draftId: this.draftId,
                    marketCooperationId: item.marketCooperationId,
                });

            const {allNum} = data;
            item.postTotal = allNum;
            item.tableData = data.preProjectMarketCooperationList;
            this.itemLoading = false;
        })
    }

    async getMarketCooperationList() {
        this.dialogPartnerLoading = true
        const data: any = await getMarketCooperationList(
            this.draftId ? {
                name: this.dialogPartnerInputValue,
                limit: this.dialogPartnerLimit,
                page: this.dialogPartnerPage,
                draftId: this.draftId
            } : {
                name: this.dialogPartnerInputValue,
                limit: this.dialogPartnerLimit,
                page: this.dialogPartnerPage
            })
        const {allNum, marketCooperationList} = data
        this.partnerTableDataDialog = marketCooperationList
        this.dialogPartnerTotal = allNum
        this.dialogPartnerLoading = false
        //   添加机构的时候关闭窗口
        this.partnerList.forEach((item, index) => {
            (this.$refs[`item${index}`][0] as HTMLElement).style.height = '50px';
            (this.$refs[`item${index}`][0] as HTMLElement).childNodes.forEach(item => {
                item.childNodes[0].childNodes.forEach(item1 => {
                    if ((item1 as HTMLElement).className == 'p_i') {
                        (item1.childNodes[0] as HTMLElement).className = 'el-icon-caret-bottom';
                    }
                })
            })
        });
    }

    async getPreProjectMarketCooperationListByMarketCooperationId(id: number, page: number) {
        let data: any;
        this.partnerList.forEach((item) => {
            if (item.marketCooperationId === id) {
                item.itemLoading = true;
                this.souCourseName = item.souCourseName

            }
        });
        if (this.draftId) {
            data = await getPreProjectMarketCooperationListByMarketCooperationId(
                {
                    limit: this.postLimit,
                    page: page,
                    draftId: this.draftId,
                    marketCooperationId: id,
                    souCourseName: this.souCourseName
                }
            )

        } else {
            data = await getPreProjectMarketCooperationListByMarketCooperationId(
                {
                    limit: this.postLimit,
                    page: page,
                    marketCooperationId: id,
                    souCourseName: this.souCourseName
                }
            )
        }

        this.partnerList.forEach((item) => {
            if (item.marketCooperationId === id) {
                const {allNum} = data
                item.postTotal = allNum
                item.tableData = data.preProjectMarketCooperationList
                item.itemLoading = false
            }
        })

        this.souCourseName = '';
        this.$forceUpdate()
    }

    /* 点击下箭头*/
    async openItem(index: number, id: number, e) {

        const className = e.target.className
        if (className.indexOf('open') !== -1) {  // 打开 => 关闭
            e.target.className = 'el-icon-caret-bottom';
            (this.$refs[`item${index}`][0] as HTMLElement).style.height = '50px'
        } else {     // 关闭 => 打开
            this.setProjectPartnerId = id
            this.getPreProjectMarketCooperationListByMarketCooperationId(id,1)
            e.target.className = 'el-icon-caret-bottom open';
            (this.$refs[`item${index}`][0] as HTMLElement).style.height = '300px'
        }
    }

    async clickPartnerDialogConfirmButton() {
        const obj = {
            marketCooperationIdList: this.dialogPartnerTableCheckedRow.map(item => item.id),
            draftId: this.draftId
        }
        if (!this.draftId) {
            delete obj.draftId
        }

        await setPreProjectMarketCooperation(obj)
        this.$message.success('添加机构成功')
        this.dialogPartnerTableCheckedRow = []
        const dom = this.$refs['dialogPartnerTable'] as HTMLFormElement
        dom.clearSelection()
        this.addPartnerDialog = false
        this.dialogPartnerInputValue = ''
        this.getPreProjectMarketCooperationList()
    }

    clickPartnerDialogCancelButton() {
        this.dialogPartnerTableCheckedRow = []
        const dom = this.$refs['dialogPartnerTable'] as HTMLFormElement
        dom.clearSelection()
        this.addPartnerDialog = false
        this.dialogPartnerInputValue = ''
    }

    dialogPartnerTableCheckedChange(arr) {
        this.dialogPartnerTableCheckedRow = arr
    }

    clickAddPartner() {
        this.addPartnerDialog = true
        this.getMarketCooperationList()
    }

    async clickDeletePartner(id: number, e, index1) {
        // if(this.partnerList.length === 1) {
        //     this.$message.error('最少保留一个机构信息')
        //     return
        // }

        await delPreProjectMarketCooperationByMarketCooperationId(this.draftId ? {
            marketCooperationId: id,
            draftId: this.draftId
        } : {marketCooperationId: id})
        this.$message.success('删除机构成功')
        this.getPreProjectMarketCooperationList()
        //     关闭小按钮
        this.partnerList.forEach((item, index) => {
            (this.$refs[`item${index}`][0] as HTMLElement).style.height = '50px';
            (this.$refs[`item${index}`][0] as HTMLElement).childNodes.forEach(item => {
                item.childNodes[0].childNodes.forEach(item1 => {
                    if ((item1 as HTMLElement).className == 'p_i') {
                        (item1.childNodes[0] as HTMLElement).className = 'el-icon-caret-bottom';
                    }
                })
            })
        })
    }

    async getProjectMarketCooperationByMarketCooperationId() {
        this.dialogProjectLoading = true
        const data: any = await getProjectMarketCooperationByMarketCooperationId({
            isTwo: '0',
            name: this.dialogProjectInputValue,
            marketCooperationIdList: [this.setProjectPartnerId],
            limit: this.dialogProjectLimit,
            page: this.dialogProjectPage,
            isDraft: this.draftId ? '1' : '0'
        })
        this.projectTableDataDialog = data.projectAllList
        this.dialogProjectTotal = data.allNum
        this.dialogProjectLoading = false
    }

    clickAddProject(id: number) {
        this.addProjectDialog = true
        this.setProjectPartnerId = id
        this.getProjectMarketCooperationByMarketCooperationId()
    }

    async clickProjectDialogConfirmButton() {
        if (this.draftId) {
            await setProjectMarketCooperation({
                marketCooperationIdList: [this.setProjectPartnerId],
                projectAllIdList: this.dialogProjectTableCheckedRow.map(item => item.id),
                isTwo: '0',
                draftId: this.draftId,
                isAll: this.isAll
            })
        } else {
            await setProjectMarketCooperation({
                marketCooperationIdList: [this.setProjectPartnerId],
                projectAllIdList: this.dialogProjectTableCheckedRow.map(item => item.id),
                isTwo: '0',
                isAll: this.isAll
            })
        }

        this.$message.success('添加项目成功')
        this.addProjectDialog = false
        this.dialogProjectTableCheckedRow = []
        this.dialogProjectInputValue = ''
        const dom = this.$refs['dialogProjectTable'] as HTMLFormElement
        dom.clearSelection()
        this.getPreProjectMarketCooperationListByMarketCooperationId(this.setProjectPartnerId, 1)
    }

    async delPreProjectMarketCooperationById(id: number,jigouId) {
        if (this.draftId) {
            await delPreProjectMarketCooperationById({id: id, draftId: this.draftId})
        } else {
            await delPreProjectMarketCooperationById({id: id})
        }
        this.$message.success('删除项目成功')
        this.getPreProjectMarketCooperationListByMarketCooperationId(jigouId, 1)
    }

    dialogProjectTableCheckedChange(arr) {
        this.dialogProjectTableCheckedRow = arr
    }

    partnerPageChange(page: number) {
        this.dialogPartnerPage = page
        this.getMarketCooperationList()
    }

    partnerLimitChange(limit: number) {
        this.dialogPartnerLimit = limit
        this.getMarketCooperationList()
    }

    projectPageChange(page: number) {
        this.dialogProjectPage = page
        this.getProjectMarketCooperationByMarketCooperationId()
    }

    projectLimitChange(limit: number) {
        this.dialogProjectLimit = limit
        this.getProjectMarketCooperationByMarketCooperationId()
    }

    dialogPartnerTableSelectable(row) {
        return row.isChoice
    }

    clickSubmitButton() {
        // if(this.partnerTableDataEmpty.length > 0) {
        //     this.confirmSubmitError = true
        //     return
        // }
        if (this.partnerTableDataError.length > 0) {
            this.submitError = true
            return
        }
        this.submit()
    }

    async submit() {
        if (this.draftId) {
            this.submitButtonDisabled = true
            this.saveButtonDisabled = true
            setDraftById({id: this.draftId, form: {}, isSubmit: '1'}).then(() => {
                this.$message.success('提交成功，页面即将关闭')
                setTimeout(() => {
                    window.close()
                }, 1500)
            }).catch(() => {
                this.submitButtonDisabled = false
                this.saveButtonDisabled = false
            })
        } else {
            this.submitButtonDisabled = true
            this.draftButtonDisabled = true
            setProjectMarketCooperationByIsDraft({isDraft: '0'}).then(() => {
                this.$message.success('提交成功, 页面即将关闭')
                setTimeout(() => {
                    window.close()
                }, 1500)
            }).catch(() => {
                this.submitButtonDisabled = false
                this.draftButtonDisabled = false
            })
        }
    }

    clickDraftButton() {
        this.submitButtonDisabled = true
        this.draftButtonDisabled = true
        setProjectMarketCooperationByIsDraft({isDraft: '1'}).then(() => {
            this.$message.success('数据已成功保存到草稿箱, 页面即将关闭')
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch(() => {
            this.submitButtonDisabled = false
            this.draftButtonDisabled = false
        })
    }

    clickSaveButton() {
        this.$message.success('保存成功，页面即将关闭')
        setTimeout(() => {
            window.close()
        }, 1500)
    }


    postPageChange(id, page: number) {
        //判断当前点击哪一条
        this.partnerList.forEach((item) => {
            if (item.marketCooperationId === id) {
                item.postPage = page
                this.getPreProjectMarketCooperationListByMarketCooperationId(id, item.postPage)

            }
        })
    }

    postLimitChange(id, limit: number) {
        this.partnerList.forEach((item) => {
            if (item.marketCooperationId === id) {
                item.postLimit = limit
                this.getPreProjectMarketCooperationListByMarketCooperationId(id, this.postPage)
            }
        })
    }
}
